import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens as sheetTokens } from '../../Sheet/tokens';

const prefixSize = 16;
const spacingTight = sheetTokens.spacing.tight / 2;

export const ActionBannerWrapper = styled.div`
    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding-top: ${spacingTight}px;
        padding-bottom: ${sheetTokens.spacing.tight}px;
    }
`;

export const Interior = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: ${sheetTokens.spacing.tight}px;
    // Extra padding before the "prefix" to assist visual alignment.
    padding: ${spacingTight}px;
    padding-left: ${sheetTokens.spacing.tight}px;
    border-radius: 9999px;
    background-color: ${({ theme }) => theme.shades.white[5]};
`;

export const PrefixWrapper = styled.div`
    display: block;
    height: ${prefixSize}px;
    width: ${prefixSize}px;
`;

export const Prefix = styled.span`
    ${styledReset.typography};
    display: block;
    font-size: ${prefixSize}px;
`;

export const ChildrenWrapper = styled.div``;

export const SuffixWrapper = styled.div`
    display: block;
    justify-self: end;
`;

///
/// Sub-components for export

export interface DepActionBannerTextHighlightProps {
    $error?: boolean;
}

export const DepActionBannerTextHighlight = styled.strong<DepActionBannerTextHighlightProps>`
    color: ${({ theme, $error }) => $error && theme.colors.red};
`;
